"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// Episerver library
const spa_core_1 = __importDefault(require("@episerver/spa-core"));
// Application
const Config_1 = __importDefault(require("./Config"));
(0, spa_core_1.default)(Config_1.default);
